function convertToInches(
  width: number,
  height: number,
  dimensionType: 'inches' | 'centimeters'
): { width: number; height: number } {
  if (!dimensionType || dimensionType === 'inches') {
    return { width, height };
  }

  // Convert centimeters to inches (1 inch = 2.54 cm)
  return {
    width: width / 2.54,
    height: height / 2.54,
  };
}

interface MockupWithDimensions {
  maxWidth?: number;
  maxHeight?: number;
  scaleFactor?: number;
  [key: string]: any;
}

function filterMockupsByDimensions<T extends MockupWithDimensions>(
  mockups: T[],
  imageWidth: number,
  imageHeight: number,
  imageDimensionType: 'inches' | 'centimeters'
): T[] {
  if (!imageWidth || !imageHeight || !imageDimensionType) {
    return mockups;
  }

  const { width: widthInInches, height: heightInInches } = convertToInches(imageWidth, imageHeight, imageDimensionType);

  return mockups.filter((mock) => {
    if (mock.maxWidth && mock.maxHeight && mock.scaleFactor) {
      const mockAllowedWidth = (mock.maxWidth * mock.scaleFactor) / 100;
      const mockAllowedHeight = (mock.maxHeight * mock.scaleFactor) / 100;
      return widthInInches <= mockAllowedWidth && heightInInches <= mockAllowedHeight;
    }
    return true;
  });
}

export { convertToInches, filterMockupsByDimensions };
